<template>
  <v-app>
    <Def>
      <v-snackbar
        v-model="snackbar"
        color="blue"
        :timeout="3000"
        top
      >Вы успешно зарегестрировались на платформе</v-snackbar>
      <v-container fluid style="width:90%" v-scroll="handleScroll">
        <v-row class="mt-n4">
          <v-img
            style="z-index:3;"
            src="https://i.ibb.co/6P0WKzM/Business-coach-talking-to-audience-Leader-or-boss-instructing-team-flat-vector-illustration-Speaker.jpg"
          >
            <v-row>
              <v-col cols="4">
                <v-spacer></v-spacer>
              </v-col>
              <v-col>
                <div class="font-weight-bold text-uppercase">
                  <p
                    class="d-none d-lg-inline-flex"
                    style="letter-spacing: 0.2em; margin-top:20%;font-size:3vw;"
                  >
                    Успех в твоих
                    <br />решениях
                  </p>
                  <p
                    class="d-xs-inline-flex d-lg-none"
                    style="letter-spacing: 0.2em; margin-top:45%;font-size:3vw;"
                  >
                    Успех в твоих
                    <br />решениях
                  </p>
                </div>
              </v-col>
            </v-row>
          </v-img>
        </v-row>
        <v-row
          style="transition: 1.5s all cubic-bezier(0.39, 0.575, 0.565, 1);transform: translateZ(0);"
          :style="{opacity: op0, marginTop: mar[0] + 'px'}"
        >
          <v-container fluid>
            <v-row>
              <v-col align="center">
                <div class="font-weight-bold" style="position:relative; z-index:3;font-size:5.3vw">
                  <p
                    class="text-uppercase"
                    style="letter-spacing: 0.30em; -webkit-text-stroke: 0.5px #50549E; color:#E5E5E5;"
                  >Здесь ты можешь</p>
                </div>
              </v-col>
            </v-row>
            <v-row style="position:relative;z-index:2; font-size:1.3vw" class="font-weight-bold">
              <v-col align="center">
                НАЙТИ
                <br />СТАЖИРОВКУ И
                <br />РАБОТУ СВОЕЙ
                <br />МЕЧТЫ
              </v-col>
              <v-col align="center">
                НАЙТИ
                <br />ЗАМОТИВИРОВАННЫХ
                <br />ЛЮДЕЙ ДЛЯ ЛЮБЫХ
                <br />ПРОЕКТОВ И ЗАДАЧ
              </v-col>
              <v-col align="center">
                УЗНАТЬ
                <br />АКТУАЛЬНОСТЬ
                <br />ПРОФЕССИЙ
                <br />НА РЫНКЕ ТРУДА
              </v-col>
            </v-row>
            <v-row style="margin-top:-12%;">
              <v-col cols="8">
                <v-img
                  style="position:relative;z-index:1;"
                  src="https://image.freepik.com/free-vector/group-students-watching-online-webinar_74855-5514.jpg"
                ></v-img>
              </v-col>
              <v-col cols="4" align="center" style="margin-top:20%;">
                <v-btn
                  rounded
                  depressed
                  color="#FFCF36"
                  class="rounded-pill d-none d-lg-inline-flex"
                  width="100%"
                  height="20%"
                  style="font-size:1.2vw"
                >
                  <v-icon left size="30">search</v-icon>Узнать больше
                </v-btn>
                <v-btn
                  rounded
                  depressed
                  color="#FFCF36"
                  class="rounded-pill d-xs-inline-flex d-lg-none"
                  width="100%"
                  height="20%"
                  style="font-size:1.2vw"
                >
                  <v-icon left size="12">search</v-icon>Узнать больше
                </v-btn>
              </v-col>
              <v-col cols="1">
                <v-spacer></v-spacer>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row
          style="transition: 1.5s all cubic-bezier(0.39, 0.575, 0.565, 1);transform: translateZ(0);"
          :style="{opacity: op1, marginTop: mar[1] + 'px'}"
        >
          <v-container fluid>
            <v-row align="center">
              <v-col cols="2">
                <v-spacer></v-spacer>
              </v-col>
              <v-col cols="3">
                <div class="font-weight-bold" style="font-size:1.5vw;">Вместе с нами</div>
                <div style="font-size:1.1vw;" class="mt-7 font-weight-regular">
                  <p
                    style="word-spacing:0.7em;line-height: 1.2em;"
                  >Работодатели заинтересованные в молодых компетентных кадрах для трудоустройства на предпритие.</p>
                </div>
              </v-col>
              <v-col cols="1">
                <v-spacer></v-spacer>
              </v-col>
              <v-col cols="5">
                <Slide class="d-none d-lg-inline-flex" :widt="80" />
                <Slide class="d-xs-inline-flex d-lg-none" :widt="40" />
              </v-col>
              <v-col cols="1">
                <v-spacer></v-spacer>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row
          style="transition: 1.5s all cubic-bezier(0.39, 0.575, 0.565, 1);transform: translateZ(0);"
          :style="{opacity: op2, marginTop: mar[2] + 'px'}"
        >
          <v-container fluid class="mt-16">
            <v-row style="position:relative;z-index:2">
              <v-col align="center">
                <div class="font-weight-bold" style="font-size:5.3vw">
                  <p
                    class="text-uppercase"
                    style="letter-spacing: 0.03em; -webkit-text-stroke: 0.5px #50549E; color:#E5E5E5"
                  >У тебя есть возможность</p>
                </div>
              </v-col>
            </v-row>
            <v-row style="position:relative;z-index:2; font-size:1.3vw" class="font-weight-bold">
              <v-col cols="1">
                <v-spacer></v-spacer>
              </v-col>
              <v-col align="center">НАЙТИ СРЕДСТВА НА РЕАЛИЗАЦИЮ СВОЕГО ПРОЕКТА</v-col>
              <v-col align="center">ИНВЕСТИРОВАТЬ В ПОНРАВИВШЕЙСЯ ПРОЕКТ</v-col>
              <v-col align="center">СОБРАТЬ КОМАНДУ КРЕАТИВНЫХ РЕБЯТ ДЛЯ ЛЮБОГО ПРОЕКТА</v-col>
              <v-col align="center">ПОПРОБОВАТЬ ПРИНЯТЬ УЧАСТИЕ В КРУТОМ ПРОЕКТЕ</v-col>
              <v-col cols="1">
                <v-spacer></v-spacer>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="1">
                <v-spacer></v-spacer>
              </v-col>
              <v-col cols="4" style="margin-top:9%;">
                <v-btn
                  rounded
                  depressed
                  color="#5B98F1"
                  class="rounded-pill d-none d-lg-inline-flex"
                  width="100%"
                  height="27%"
                  style="font-size:1.2vw"
                >
                  <v-icon left size="30">search</v-icon>Узнать больше
                </v-btn>
                <v-btn
                  rounded
                  depressed
                  color="#5B98F1"
                  class="rounded-pill d-xs-inline-flex d-lg-none"
                  width="100%"
                  height="27%"
                  style="font-size:1.2vw"
                >
                  <v-icon left size="12">search</v-icon>Узнать больше
                </v-btn>
              </v-col>
              <v-col cols="1">
                <v-spacer></v-spacer>
              </v-col>
              <v-col cols="6">
                <v-img
                  style="position:relative;z-index:1"
                  src="https://image.freepik.com/free-vector/team-starting-project_74855-4818.jpg"
                ></v-img>
              </v-col>
              <v-col cols="1">
                <v-spacer></v-spacer>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row
          style="transition: 1.5s all cubic-bezier(0.39, 0.575, 0.565, 1);transform: translateZ(0);"
          :style="{opacity: op3, marginTop: mar[3] + 'px'}"
        >
          <v-container fluid>
            <v-row align="center">
              <v-col cols="1">
                <v-spacer></v-spacer>
              </v-col>
              <v-col cols="5">
                <Slide class="d-none d-lg-inline-flex" :widt="80" />
                <Slide class="d-xs-inline-flex d-lg-none" :widt="40" />
              </v-col>
              <v-col cols="1">
                <v-spacer></v-spacer>
              </v-col>
              <v-col cols="3" align="start">
                <div class="font-weight-bold" style="font-size:1.5vw;">ТОП студентов</div>
                <div class="mt-7 font-weight-regular" style="font-size:1.1vw;">
                  <p
                    style="word-spacing:0.7em;line-height: 1.2em;"
                  >Студенты различных универститетов хотят повышать свои знания в актуальных и востребованных профессиях</p>
                </div>
              </v-col>
              <v-col cols="2">
                <v-spacer></v-spacer>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
      </v-container>
    </Def>
  </v-app>
</template>

<script>
import Slide from "./gslide";
export default {
  components: {
    Slide,
  },
  data: () => ({
    show: false,
    op0: 0,
    op1: 0,
    op2: 0,
    op3: 0,
    mar: [300, 300, 300, 300],
    snackbar: false,
  }),
  created() {
    if (this.$route.query.m == "success") {
      this.snackbar = true;
      this.$router.replace("/");
    }
  },
  methods: {
    handleScroll: function () {
      if (window.scrollY > 400) {
        this.op0 = 1;
        this.mar[0] = 0;
      }
      if (window.scrollY > 1000) {
        this.op1 = 1;
        this.mar[1] = 0;
      }
      if (window.scrollY > 1700) {
        this.op2 = 1;
        this.mar[2] = 0;
      }
      if (window.scrollY > 2400) {
        this.op3 = 1;
        this.mar[3] = 0;
      }
      return window.scrollY > 10;
    },
  },
};
</script>
